import { WorkflowColumns } from '../models/importModels'

function readFileAsText(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result as string)
        reader.onerror = () => reject(reader.error)
        reader.readAsText(file)
    })
}

function detectDelimiter(line: string): string {
    const commaCount = (line.match(/,/g) ?? []).length
    const semicolonCount = (line.match(/;/g) ?? []).length
    return semicolonCount > commaCount ? ';' : ','
}

export async function parseCsvContent(file: File): Promise<{ headers: string[]; hasDataRows: boolean }> {
    const text = await readFileAsText(file)
    const lines = text.split(/\r?\n/)
    const firstLine = lines[0]
    const delimiter = firstLine ? detectDelimiter(firstLine) : ','
    const headers = firstLine ? firstLine.split(delimiter).map((h) => h.trim().replace(/^"|"$/g, '')) : []
    const hasDataRows = lines.slice(1).some((line) => line.trim() !== '')
    return { headers, hasDataRows }
}

export async function parseCsvHeaders(file: File): Promise<string[]> {
    const { headers } = await parseCsvContent(file)
    return headers
}

export async function validateCsvHasDataRows(file: File): Promise<void> {
    const { hasDataRows } = await parseCsvContent(file)
    if (!hasDataRows) {
        throw new Error('CSV_NO_DATA_ROWS')
    }
}

export function validateCsvHeaders(headers: string[], columns: WorkflowColumns): string[] {
    const headerSet = new Set(headers)
    return columns.required.filter((col) => !headerSet.has(col))
}
